import { Button } from "../../../../components/ui/button";
import { useStepper } from "../../../../components/ui/stepper";

const StepperNavigation = ({ sections, fetchAnalysis }) => {
  const { activeStep, nextStep, prevStep } = useStepper();

  const isLastQuestionStep = activeStep === sections.length - 1;
  const isSummaryStep = activeStep === sections.length;

  return (
    <div className="flex justify-end gap-3 mt-6">
      {activeStep > 0 && (
        <Button variant="secondary" onClick={prevStep}>
          Previous
        </Button>
      )}

      {!isSummaryStep && (
        <Button
          onClick={() => {
            if (isLastQuestionStep) {
              fetchAnalysis(sections);
            }
            nextStep();
          }}
        >
          Next
        </Button>
      )}
    </div>
  );
};

export default StepperNavigation;